<mat-toolbar class="toolbar bottom-toolbar ac-flex ac-sp-btw ac-algn-ctr">
  @if (authReady()) { @if (!user()) {
  <button
    mat-flat-button
    type="button"
    class="auth-btn ac-neutral ac-flex-itm-50"
    (click)="openAuthDialog()"
  >
    Login
  </button>
  <button
    mat-flat-button
    type="button"
    class="auth-btn ac-flex-itm-50"
    (click)="openAuthDialog('signup')"
  >
    Sign Up
  </button>
  } @else {
  <button
    mat-fab
    class="nav-btn"
    type="button"
    routerLink="/"
    (click)="shell.closeSidenavs()">
    <div
      class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm"
      [class.open]="homeOpen()">
      <ac-icon iconKey="hr:home" [size]="24" />
      HOME
    </div>
  </button>

  <button
    mat-fab
    class="nav-btn"
    type="button"
    routerLink="/games"
    (click)="shell.closeSidenavs()">
    <div
      class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm"
      [class.open]="browseOpen()">
      <ac-icon iconKey="hr:search" [size]="24" />
      BROWSE
    </div>
  </button>

  <button mat-fab class="nav-btn" (click)="walletDialog.openWalletModal()">
    <div class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm">
      <ac-icon iconKey="hr:wallet" [size]="24" />
      WALLET
    </div>
  </button>

  <button
    mat-fab
    class="nav-btn"
    type="button"
    routerLink="/promotions"
    (click)="shell.closeSidenavs()">
    <div
      class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm promo-pill-container"
      [class.open]="promotionsOpen()">
      @if (promotionsCount()) {
        <div class="promo-pill">{{ promotionsCount() }}</div>
      }

      <ac-icon iconKey="hr:gift" [size]="24" />
      PROMOS
    </div>
  </button>

  @if (merchView.merchExperience()) {
  <button
    mat-fab
    class="nav-btn"
    type="button"
    (authClick)="goToShop()"
    [enforceTimeout]="true"
    [enforceRegion]="true">
    <div class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm">
      <img src="images/merch_bag_3d.webp" alt="" width="24" height="24" />
      SHOP
    </div>
  </button>
  }

  <!--      <button mat-icon-button class="chat-btn">-->
  <!--        <ac-icon iconKey="hr:chat_bubble" [size]="24" />-->
  <!--      </button>-->

  <!--      <button mat-icon-button class="friends-btn" (click)="shell.toggleRightSidenav()">-->
  <!--        <ac-icon iconKey="hr:people" [size]="32" />-->
  <!--      </button>-->

  <button mat-fab class="nav-btn" (click)="shell.toggleLeftSidenav()">
    <div
      class="ac-flex-col ac-label ac-title-sm ac-ctr ac-gap-sm"
      [class.open]="shell.leftSidenavIsOpen$ | async"
    >
      <img
        [src]="
          user()?.avatar_url ?? ('cdnUrl' | env) + '/images/default_avatar.webp'
        "
        class="user-avatar"
        alt="user-avatar"
      />
      MENU
    </div>
  </button>
  } } @else {
  <div class="centered">
    <ac-loading [size]="30" />
  </div>
  }
</mat-toolbar>
